import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { employmentSpecialRelationshipsPastQuery } from '@/__generated__/employmentSpecialRelationshipsPastQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SurveyLayout } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { SpecialRelationshipsContainer } from '@/components/survey/employment/special-relationships/SpecialRelationshipsContainer';
import { specialRelationshipsPastQuery } from '@/graphql/query/survey/employment';
import { refundHistoryIdAtom } from '@/lib/stores/survey/common';

function SpecialRelationShipsQuestionPage() {
  const [queryRef, loadQuery] = useQueryLoader<employmentSpecialRelationshipsPastQuery>(specialRelationshipsPastQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId) {
      loadQuery({ refundHistoryId }, { fetchPolicy: 'network-only' });
    }
  }, [refundHistoryId, loadQuery]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_special-relationships'} eventProperty={eventAttributes}>
      <SpecialRelationshipsContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

SpecialRelationShipsQuestionPage.getLayout = SurveyLayout;

export default SpecialRelationShipsQuestionPage;
